import useScript from 'react-script-hook'
import { spiSdkSrc } from '../../api/util'
import { SpiSdk } from './types'
import { useSentry } from 'banquet-runtime-modules'
import { useEffect } from 'react'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { useFlags } from '@local/do-secundo-feature-flags'

declare global {
  interface Window {
    Toast: SpiSdk
  }
}

export const useSpiSdk = () => {
  const { nvsCooSpi: spiFeatureEnabled } = useFlags()
  const { isIntlRx } = useRestaurant()

  const spiEnabled = !isIntlRx && spiFeatureEnabled

  const { captureException } = useSentry()

  const [loading, error] = useScript({
    src: spiEnabled ? spiSdkSrc : null
  })

  useEffect(() => {
    if (!loading && error) {
      captureException(
        new Error(
          `SPI - Failed to load SDK: ${error.message ?? JSON.stringify(error)}`
        )
      )
    } else if (!loading && !error) {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, loading])

  return !loading && !error && typeof window !== 'undefined'
    ? window.Toast
    : undefined
}
